import { useLazyQuery } from "@apollo/client";
import { useRef, useState } from "react";
import { SEARCH_OMS_USERS } from "../../graphql/user-gql";
import { FetchPolicyOption } from "../../services/apollo/apollo";
import { IOmsUsersResponse, ISearchUsersInput, ISearchUsersResult } from "../../types/user";
import AccordionContainer from "../common/accordion-container";
import OmsUsersTable, { OmsUsersTableRef } from "./oms-users-table";
import UserSearchForm from "./user-search-form";
import { equals, isPositiveNumber, toOrdered } from "../../utils/commons";

export function OmsUsers() {
  const [results, setResults] = useState<ISearchUsersResult[]>();

  const [search, { loading }] = useLazyQuery<IOmsUsersResponse>(SEARCH_OMS_USERS, FetchPolicyOption.NetworkOnly);

  const usersTableRef = useRef<OmsUsersTableRef>(null);

  const handleSubmit = (input: ISearchUsersInput) => {
    setResults(undefined);

    search({ variables: { input } })
      .then(response => {
        let results = response.data?.omsUsers;

        if (isPositiveNumber(input.orgId)) {
          results = toOrdered(results,
            (item) => item.assignedRoles?.some(ar => equals(ar.orgScope?.id, input.orgId)) ? -1 : 0
          );
        }

        setResults(results);
      });
  };

  const handleReset = () => setResults(undefined);

  return (
    <>
      <h1 className="hidden-text">OMS Users</h1>
      <AccordionContainer title="Search OMS Users">
        <UserSearchForm onSubmit={handleSubmit} onReset={handleReset}
          onExport={() => usersTableRef.current?.export()}
          hasData={results && results.length > 0} busy={loading} />

        <OmsUsersTable data={results} pageSize={20} ref={usersTableRef} />
      </AccordionContainer>
    </>
  );
}
